import { useState, useEffect } from 'react';
import ExpenseHeader from './expense-header.jsx';
import ExpensePage from './expense-page.jsx';
import "../../../styles/Auth/expense.css";

const Expense = () => {
    const [expenses, setExpenses] = useState([]);
    const [totals, setTotals] = useState({});
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    // ⭐ Main Date Filters (used by Header API)
    const [dateFilters, setDateFilters] = useState({
        startDate: "",
        endDate: ""
    });

    // ⭐ Store top filter (All/Daily/Weekly/...)
    const [topFilter, setTopFilter] = useState("all");

    // ⭐ Trigger API refresh
    const [refreshKey, setRefreshKey] = useState(0);

    const startDate = dateFilters.startDate;
    const endDate = dateFilters.endDate;

    console.log("Selected Start Date:", startDate);
console.log("Selected End Date:", endDate);

    return (
        <div className="Expense-layout">
            <div className="Expense-content">
                <main className="Expense-main">
                    <ExpenseHeader
                        onDataFetched={(data, totals, totalCount, totalPages) => {
                            setExpenses(data);
                            setTotals(totals);
                            setTotalCount(totalCount);
                            setTotalPages(totalPages);
                        }}
                        totals={totals}
                        currentPage={currentPage}
                        dateFilters={dateFilters}
                        refreshKey={refreshKey}
                        topFilter={topFilter}
                        startDate={startDate}    // ⬅ added
                        endDate={endDate}        // ⬅ added
                        setTopFilter={setTopFilter}
                        setDateFilters={setDateFilters}
                        searchQuery={searchQuery}
                        limit={limit}
                    />
                </main>

                <div className="Expense-body">
                    <ExpensePage
                        expenses={expenses}
                        totalCount={totalCount}
                        totalPages={totalPages}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        filters={dateFilters}
                        setFilters={setDateFilters}
                        startDate={startDate}    // ⬅ added
                        endDate={endDate}        // ⬅ added
                        setRefreshKey={setRefreshKey}
                        searchQuery={searchQuery}
                        setSearchQuery={setSearchQuery}
                        topFilter={topFilter}
                        limit={limit}
                        setLimit={setLimit}
                    />
                </div>
            </div>
        </div>
    );
};
export default Expense;